import React from 'react';
import { Field } from 'formik';
import { CheckboxWithLabel } from 'formik-material-ui';

const CheckboxField = (props: any) => (
  <Field {...props} variant="outlined" component={CheckboxWithLabel} Label={{ label: props.label }} />
);

export default CheckboxField;
